export default "__VITE_ASSET__BRtISyw2__"